module.exports = __webpack_public_path__ + "static/media/ALPHA.2d31513c.svg";